// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".img-control .default-view{margin-bottom:10px}.img-control .fa{padding-right:5px}\n", "",{"version":3,"sources":["webpack://./src/styles/img-control.scss"],"names":[],"mappings":"AAAA,2BAEI,kBAAmB,CAFvB,iBAKI,iBAAkB","sourcesContent":[".img-control {\n  .default-view {\n    margin-bottom: 10px;\n  }\n  .fa {\n    padding-right: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
